var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-full-screen"},[_c('div',{staticClass:"animation-box"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":50,"width":50}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }